import { render, staticRenderFns } from "./PolarAreaChart.vue?vue&type=template&id=634fd817"
import script from "../../../scripts/partials/dashboard-charts/PolarAreaChart.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/dashboard-charts/PolarAreaChart.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports